import { StyleSheet } from "react-native";
import { height, width } from "../../utils/utils";
export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  imgDetail: {
    maxWidth: 120,
    width: "40%",
    height: 110,
    borderRadius: 29,
  },
  viewDetail: {
    flexDirection: "row",
    borderTopColor: "#9cbee7",
    borderBottomWidth: 1,
    borderBottomColor: "#9cbee7",
    height: 147,
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: width * 0.04,
  },
  textDetail: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  textDetailRespons: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  buttonInfo: {
    width: 69,
    height: 38,
    borderRadius: 9,
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
    marginTop: 17,
  },
  textInfo: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    alignSelf: "center",
  },
  textInfoRespons: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    alignSelf: "center",
  },
  buttonSendMail: {
    maxWidth: 104,
    width: "100%",
    height: 43,
    borderRadius: 25,
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
  },
  textSendMail: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2D69AE",
    alignSelf: "center",
  },
  viewTopic: {
    flexDirection: "row",
    marginTop: 27,
    paddingBottom: 10.5,
    width: "100%",
    paddingHorizontal: width * 0.04,
    justifyContent: "space-between",
  },
  textTitle: {
    fontSize: 18,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  textTitleRespons: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  sizeCountry: {
    width: "60%",
    marginLeft: 10,
    textAlign: "left",
  },
  sizeImg: {
    width: "25%",
    flexDirection: "row",
  },
  ModalSendMail: {
    width: width * 0.4,
    height: 99,
    borderWidth: 1,
    alignSelf: "center",
    justifyContent: "center",
    marginTop: 40,
  },
  textModalSendMail: {
    fontSize: 28,
    fontFamily: "Segoe",
    alignSelf: "center",
  },
});
export const stylesResponsive = StyleSheet.create({
  textDetail: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  viewDetail: {
    flexDirection: "row",
    borderTopColor: "#9cbee7",
    borderBottomWidth: 1,
    borderBottomColor: "#9cbee7",
    justifyContent: "space-between",
    paddingHorizontal: width * 0.04,
    paddingVertical: 20,
  },
  textTitle: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 10,
  },
  buttonInfo: {
    width: 50,
    height: 30,
    borderRadius: 9,
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
    marginTop: 10,
  },
  textInfo: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    alignSelf: "center",
  },
  buttonSendMail: {
    maxWidth: 80,
    width: "100%",
    height: 40,
    borderRadius: 15,
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
    marginTop: 20,
  },
  textSendMail: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2D69AE",
    alignSelf: "center",
  },
  ModalSendMail: {
    width: width * 0.8,
    height: 99,
    borderWidth: 1,
    alignSelf: "center",
    justifyContent: "center",
    marginTop: 40,
  },
  textModalSendMail: {
    fontSize: 22,
    fontFamily: "Segoe",
    alignSelf: "center",
  },
});
